<template>
  <section class="company-introduction">
    <el-row>
      <el-col :xs="24" :md="{span: 10, offset: 2}">
        <Slogn title1="「合作·互助·創新」理念" title2="「共創·共富·共享」目標" sub-title="Join Hands to Create the Future." />
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" class="hidden-md-and-up ">
        <div class="banner" />
      </el-col>
      <el-col :xs="24" :md="{span: 10, offset: 2}">
        <Title title="Introduction" sub-title="合作社介紹" class="hidden-sm-and-down" />
        <p>
          “合作社”就是為落實“合作經濟”所設立的組織，於1955 年/ 國際合作社聯盟(ICA)聲明：合作社乃是基於共同所有及民主管理的企業體，為滿足共同的經濟、社會、文化需求與願望，而自願結合之自治團體。於2015年/ 合作社法 (內政部民國104年6月3日修正)本法所稱合作社，謂依平等原則，在互助組織之基礎上，以共同經營方法謀社員經濟之利益與生活之改善，而其社員人數及股金總額均可變動之團體。
        </p>
      </el-col>
      <el-col :md="10" class="hidden-sm-and-down">
        <div class="banner" />
      </el-col>
    </el-row>
  </section>
</template>
<script>
import Slogn from '@/components/Slogn'
import Title from '@/components/Title'
export default {
  components: {
    Slogn,
    Title
  }
}
</script>
<style scoped lang="scss">
.banner {
  background-image: url('../../assets/img/introduction-pc.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100vw;
  height: 50vh;
  margin: 0 -20px 20px;
  @include minWidth992 {
    width: 100%;
    margin: 0 0 20px;
    //background-image: url('../../assets/img/introduction-pc.png');
  }
}
.company-introduction {
  .title {
    text-align: center;
  }
  ::v-deep.sub-title {
    left: 0;
  }
}
.mobile-banner {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100vw;
  height: 30vh;
  background: red;
  margin: 0 -20px 20px;
  .title {
    margin: 0;
  }
}
</style>
